const SCRIPT_DATA_ATTR = 'data-swap-secure-card-viewer';
export function loadSwapSecureCardViewerScript(scriptUrl) {
    const trimmedUrl = scriptUrl.trim();
    if (!trimmedUrl) {
        return Promise.reject(new Error('script'));
    }
    if (typeof globalThis.swap === 'function') {
        return Promise.resolve();
    }
    const existing = document.querySelector(`script[${SCRIPT_DATA_ATTR}="true"]`);
    if (existing) {
        return new Promise((resolve, reject) => {
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => reject(new Error('script')), { once: true });
        });
    }
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = trimmedUrl;
        script.async = true;
        script.setAttribute(SCRIPT_DATA_ATTR, 'true');
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('script'));
        document.head.appendChild(script);
    });
}
